
import React from "react";
import { Card, Row, Col } from "react-bootstrap";

export default function Contact() {
  return (
    <Card className="mb-3">
      <Card.Header>
        <h3 className="text-primary-label">Contact Us</h3>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col md={6}>
            <h5>Customer Support</h5>
            <p>Email: <a href="mailto:support@lupiecommunity.com">support@lupiecommunity.app</a></p>
            <p>Phone: 080-44854486</p>
          </Col>
          <Col md={6}>
            <h5>Office Address</h5>
            <p>
              Lupie Community Pvt Ltd<br />
              2nd Floor, Tech Park,<br />
              Bangalore, Karnataka, India
            </p>
          </Col>
        </Row>
        <h5 className="mt-3">Business Hours</h5>
        <p>Monday - Saturday: 9:00 AM - 6:00 PM</p>
      </Card.Body>
    </Card>
  );
}
